module.exports = __webpack_public_path__ + "media/images/landing/en/manage@2x-accfe1b25eb27c98ee5a1d6a2cc46eeb.png";